// extracted by mini-css-extract-plugin
export default {"sozdat_text":"CreateProjectButton_sozdat_text__HoeVT","create_button":"CreateProjectButton_create_button__oVbsO"};